export const duplicateFavoriteDisplayNameTemplate = "AzGVnd";
export const duplicateFavoriteTooltipTemplate = "gyJ$3d";
export const duplicateFavoriteParentFolderTemplate = "JXNPve";
export const siderailFavoriteTooltipTemplate = "g7BCN";
export const siderailFavoriteTooltipAccountSuffixTemplate = "GxgmCc";
export default {duplicateFavoriteDisplayNameTemplate,duplicateFavoriteTooltipTemplate,duplicateFavoriteParentFolderTemplate,siderailFavoriteTooltipTemplate,siderailFavoriteTooltipAccountSuffixTemplate};